<template>
  <div class="documentMargins-content view-main-content view-main-content--footered">
    <ViewNavigationBar
      :title="$t('views.DocumentMargins.title', [typeDocument])"
      :subtitle="subTitle"
      has-refresh-button
      has-back-button
      help-id="56"
    />
    <div class="view-main-content--footered">
      <div class="radioButtonList columns">
        <div
          v-for="(radioButton, radioIndex) in radioButtons"
          :key="radioIndex"
        >
          <SimpleRadio
            v-model:model="selectedRadio"
            :value="radioButton.value"
            :label="radioButton.label"
            :class="{'has-margin-left-4': radioIndex > 0}"
            appearance="primary"
            @change="radioChange()"
          />
        </div>
      </div>
      <section class="documents-table box-with-shadow">
        <DataTable
          :ready="listIsReady"
          :data="listRows"
          name="DocumentMargins"
          @change="dataChange"
        >
          <DataTableColumn
            name="article"
            width="130px"
            class="product-code-column"
          />
          <DataTableColumn
            name="description"
          />
          <DataTableColumn
            name="quantity"
            align="right"
            type="quantity"
          />
          <DataTableColumn
            name="price"
            align="right"
            type="currency"
          />
          <DataTableColumn
            name="cost"
            align="right"
            type="currency"
          />
          <DataTableColumn
            name="margin"
            align="right"
          >
            <template #default="{ cell, row }">
              <div>
                <span
                  :class="[{'negative-value': row.isNegative}]"
                >
                  {{ $filters.percentage(cell) }}
                </span>
              </div>
            </template>
          </DataTableColumn>
        </DataTable>
        <div
          v-if="showFooter"
          class="fake-table-footer"
        >
          <AmountCard
            :v-if="showFooter==true"
            :amount="footerData.valfat"
            :label="$t('views.DocumentMargins.totalFatt')"
            appearance="offers"
          />
          <AmountCard
            :v-if="showFooter==true"
            :amount="footerData.valcost"
            :label="$t('views.DocumentMargins.totalCost')"
            appearance="orders"
          />
          <AmountCard
            :v-if="showFooter==true"
            :amount="footerData.margin"
            :label="$t('views.DocumentMargins.totalMargin')"
            symbol-amount="%"
            appearance="sales"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useRootStore } from '@/stores/root';
import { useDocumentsStore } from '@/stores/documents';
import list from '@/mixins/list';
import ViewNavigationBar from '@/components/bars/ViewNavigationBar.vue';
import DataTableColumn from '@/components/table/DataTableColumn.vue';
import DataTable from '@/components/table/DataTable.vue';
import AmountCard from '@/components/cards/AmountCard.vue';
import SimpleRadio from '@/components/radio/SimpleRadio.vue';

const footerData = {
  valfat: 0,
  valcost: 0,
  margin: 0,
};

export default {
  name: 'DocumentMargins',
  components: {
    ViewNavigationBar,
    DataTableColumn,
    DataTable,
    AmountCard,
    SimpleRadio,
  },
  mixins: [list],
  data() {
    return {
      listKey: 'documentMargins',
      footerData,
      radioButtons: [
        {
          label: this.$t('views.DocumentMargins.listCost'),
          value: 'L',
        },
        {
          label: this.$t('views.DocumentMargins.lastCost'),
          value: 'U',
        },
        {
          label: this.$t('views.DocumentMargins.middleCost'),
          value: 'M',
        },

      ],
      selectedRadio: 'L',
    };
  },
  computed: {
    ...mapState(useRootStore, [
      'documentHead',
      'user',
    ]),
    subTitle: {
      get() {
        const titleHead = `${this.documentHead}`;
        return titleHead;
      },
    },
    typeDocument() {
      return this.$route.params.type;
    },
    showFooter() {
      if (this.listRows && this.listRows.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(useDocumentsStore, [
      'getDocumentMargins',
    ]),
    async radioChange() {
      this.refresh();
    },
    async getRows() {
      const id = this.$route.params.documentId;
      // TODO: error in API
      const rows = await this.getDocumentMargins({
        numpro: id,
        tipcos: this.selectedRadio,
        forceRefresh:true,
      }) || [];
      return rows.map(item => ({
        article: item.codmar.concat(' ', item.codart),
        description: item.desart,
        quantity: item.qtadoc,
        price: parseFloat(item.prznet),
        cost: parseFloat(item.cosart),
        valfat: parseFloat(item.valfat),
        valcos: parseFloat(item.valcos),
        margin: item.valmar,
        isNegative: item.valmar < 0.00,
      }));
    },
    dataChange(newData) {
      if (!newData) this.footerData = footerData;
      else {
        const { costAmount, fattAmount } = newData.reduce((acc, item) => ({
          costAmount:
            !Number.isNaN(item.valcos) ?
              acc.costAmount +
              item.valcos : acc.costAmount,
          fattAmount:
            !Number.isNaN(item.valfat) ?
              acc.fattAmount +
              item.valfat : acc.fattAmount,
        }), { costAmount: 0, fattAmount: 0 });
        this.footerData = {
          valfat: fattAmount.toFixed(2),
          valcost: costAmount.toFixed(2),
          margin: this.calculateMargin(fattAmount.toFixed(2), costAmount.toFixed(2)),
        };
      }
    },
    calculateMargin(price, cost) {
      return (((price - cost) / price) * 100).toFixed(2);
    },
  },
};
</script>

<style scoped lang="scss">
.documentMargins-content {

  .negative-value {
    color: $red-orange;
  }
  .fake-table-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1.5rem;
  }
  .radioButtonList{
    display: flex;
    padding-left: 10px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

}
</style>
